<template>
  <div class="main-layout chat">
    <v-row>
      <v-col :cols="12" :lg="8" :md="8" :sm="12" class="pt-3">
        <section class="live">
          <!-- <div class="pb-8">
            <div
              :class="[$vuetify.breakpoint.lgAndUp ? 'display-1': 'headline']"
              style="margin-left: 10px;"
            >{{ courseTitle }}</div>
          </div>-->
          <UpperDisplay />
          <LowerDisplay />
        </section>
      </v-col>
      <!-- <LiveMenu /> -->
      <v-col :cols="12" :lg="4" :md="4" :sm="12" class="pt-3">
        <div class="mb-3">
          <div class="header-option">
            <v-col class="menu-title d-flex align-center">
              <v-col class="pa-0 live-text" cols="auto">
                <h4>Live chat</h4>
              </v-col>
              <v-col class="pa-0 live-text pl-3 pr-3">
                <v-select
                  :items="rooms"
                  item-text="title"
                  v-model="currentRoom"
                  item-value="_id"
                  solo
                  rounded
                  hide-details
                  flat
                ></v-select>
              </v-col>
              <v-col class="pa-0" cols="auto">
                <v-btn class="blue" icon @click="refreshRooms()"><v-icon color="white">
                mdi-refresh
                </v-icon></v-btn>
              </v-col>
            </v-col>
          </div>
          <div class="option-content">
            <Chatboard courseId="5ea54d75703dc757e34a4207" liveId="live_5ecce5481b2bae256ba3736a" :chatRoom.sync="currentRoom" />
          </div>
        </div>
      </v-col>
      <ImageLecture />
      <Exam />
      <NameCheck />
      <EndLive />
    </v-row>
  </div>
</template>

<script>
import LiveMenu from "../../components/live/LiveMenu.vue";
import UpperDisplay from "../../components/live/UpperDisplay.vue";
import LowerDisplay from "../../components/live/LowerDisplay.vue";
import Chatboard from "../../components/live/Chatboard.vue";
import Exam from "../../components/live/Dialog/QuestionDialog.vue";
import NameCheck from "../../components/live/Dialog/NameCheck.vue";
import EndLive from "../../components/live/Dialog/EndLive.vue";
import ImageLecture from "../../components/live/Dialog/Image.vue";
import { mapState } from "vuex";

export default {
  name: "classroom",
  components: {
    LiveMenu,
    UpperDisplay,
    LowerDisplay,
    Chatboard,
    Exam,
    NameCheck,
    ImageLecture,
    EndLive,
  },
  data: () => ({
    currentRoom: null,
  }),
  computed: {
    ...mapState({
      courseTitle: state => (state.liveDetail ? state.liveDetail.title : ""),
      rooms: state => state.liveRooms,
    })
  },
  methods: {
    toggleDashboard() {
      this.$store.dispatch("toggleDashboard");
    },
    refreshRooms() {
      const rawId = this.$route.params.id.split("-");
      const liveId = rawId[1];
      this.$store.dispatch("fetchRoom", {liveId});
    }
  },
  watch: {
    rooms(newValue) {
      if (newValue && newValue.length > 0) {
        this.currentRoom = null;
      }
    }
  },
  beforeMount() {
    this.$store.dispatch("fetchServerTime");
  },
  mounted() {
    const rawId = this.$route.params.id.split("-");
    const courseId = rawId[0];
    const liveId = rawId[1];
    this.$store.dispatch("fetchRoom", {liveId});
    this.$store.commit("initLive", rawId);
    const newLive = this.$route.query.newLive;
    this.$store.dispatch("fetchLive", {newLive});
    // this.$store.dispatch("fetchServerTime");
  }
};
</script>
<style scoped>
.header-option {
  background: #e77b9f;
  color: white;
}
.menu-title {
  padding: 20px;
}
.live-text {
  font-size: 18px;
  font-weight: 400px;
}
</style>
<style lang="scss">
@import "./../../scss/classroom/main-layout.scss";
</style>
